import {getAxios, getEndpointBase} from "./base.api";
import * as querystring from "../utils/querystring";
import { getLanguageCode } from "../../selectors/generic";
import { isLoggedIn } from "../../data/user.model";
import { AnonProducts, Products } from "../../interfaces/ecom/schema";

const AUTHENTICATED_ENDPOINT = "GetProductRecommendations";
const ANONYMOUS_ENDPOINT = "GetAnonRecommendations";

const LIMIT = 10;

const axios = getAxios();

interface IRequestData {
    AEMProductID: string;
}

export async function getProductRecommendations({AEMProductID}: IRequestData): Promise<Products | AnonProducts> {
    const countryLanguage = getLanguageCode();
    const apiUrl = isLoggedIn() ? getEndpointBase(AUTHENTICATED_ENDPOINT) : getEndpointBase(ANONYMOUS_ENDPOINT);

    const queryString = querystring.stringify({
        AEMProductID,
        Language: countryLanguage,
        limit: LIMIT
    });

    try {
        const response = await axios.get(`${apiUrl}?${queryString}`);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        } else {
            throw new Error(`API Endpoint error: ${response.statusText}`)
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

